module.exports = __webpack_public_path__ + "static/media/wi-night-clear.f86c33c4.svg";